export class Perfil {
  id!: number;
  descricao!: string;
  acessaFinanceiro!: boolean;
  cadastraServico!: boolean;
  acessoOrcamentoPerfil!: string;
  acessoOSPerfil!: string;
}
